import { CountryDTO } from "../dto/CountryDTO";
import { Country } from "../models/Country";

export const countryMapper = (dto: CountryDTO): Country => {
  return new Country({
    id: dto.countryId,
    name: dto.countryName,
    code: dto.abbrev,
  });
};
